enum NumberFormatReturnedValues {
  FORMATTED = 'formattedValue',
  FLOAT_VALUE = 'floatValue',
  VALUE = 'value',
}

export default NumberFormatReturnedValues;
